import {Frame} from "../z40-uicomp/frame";
import {CenteredCard} from "../z40-uicomp/centered-card";
import * as React from "react";
import {HeadingLarge} from "baseui/typography";
import {SpaceBottom} from "../z40-uicomp/layout";

export function JoinOurTeam() {
    return (
        <Frame>
            <SpaceBottom>
                <CenteredCard showRobot={false} maxWidth={1024}>
                    <HeadingLarge marginTop="0">
                        Join our team
                    </HeadingLarge>
                    <p>
                        We are not using the Plasmic-powered careers page anymore.
                        Please check our main website or contact us directly for open roles.
                    </p>
                </CenteredCard>
            </SpaceBottom>
        </Frame>
    );
}